<template>
    <div class="waybillListWarpper" ref="waybillList">
        <div class="__header">
            <div class="__header__title" v-show="isExpand">运单监控</div>
            <div :class="['iconList', !isExpand ? 'toggle' : '']">
                <i class="el-icon-search" @click="handleClickSearch"></i>
                <i class="el-icon-refresh" @click="handleRefresh"></i>
                <i class="el-icon-s-fold" @click="handleExpand"></i>
            </div>
        </div>
        <div class="order-list-main" v-loading="listLoading">
            <div class="order-list" v-show="isExpand">
                <div
                    :class="[
                        'order-item',
                        item.id === activeId ? 'active' : '',
                    ]"
                    v-for="item in orderList"
                    :key="item.id"
                    @click="handleChange(item)"
                >
                    <div class="item-head">
                        <span>{{ item.taskNo }}</span>
                        <span>{{
                            dictData.TMS_TASK_STATUS[item.taskStatus]
                        }}</span>
                    </div>
                    <div
                        class="item-arrival-time"
                        v-if="item.requireArriveTime"
                    >
                        要求运抵时间: {{ item.requireArriveTime }}
                    </div>
                    <div class="item-customer-name" v-if="item.customerName">
                        客户: {{ item.customerName }}
                    </div>
                    <div class="item-content">
                        {{ item.senderDetailAddr }}&nbsp;→&nbsp;{{
                            item.receiverDetailAddr
                        }}
                    </div>
                </div>
            </div>
            <!-- 分页 -->
            <div class="waybillMapMonitorPagination" v-show="isExpand">
                <div v-if="orderList.length > 0">
                    <el-pagination
                        small
                        layout="prev, pager, next"
                        :total="pageTotal"
                        :current-page.sync="query.pageNo"
                        @current-change="handleCurrentChange"
                    >
                    </el-pagination>
                    <div class="pageFooter">
                        <div class="pagaTotal">共{{ pageTotal }}条</div>
                        <div class="toTargetPage">
                            前往：<el-input
                                v-model="inputPageNo"
                                @keyup.enter.native="
                                    handleCurrentChange(Number(inputPageNo))
                                "
                            />页
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 查询表单 -->
        <waybill-map-monitor-search
            v-if="visibleSearchForm"
            @search="handleSearch"
        ></waybill-map-monitor-search>
    </div>
</template>
<script>
import WaybillMapMonitorSearch from './WaybillMapMonitorSearch.vue';
import { dictWithUrl } from '@/components/lots/api.js';
import { queryMapMonitorList, queryCount } from '../../../../api/performanceWaybillMapMonitor.js';
import { mapState } from 'vuex';
export default {
    name: 'performanceWaybillList',
    components: {
        WaybillMapMonitorSearch
    },
    props: {
        isExpand: Boolean
    },
    data () {
        return {
            visibleSearchForm: false, // 是否显示查询表单
            pageTotal: 0, // 分页总数据
            orderListHeight: 0, // 左侧列表区域高度
            inputPageNo: 1,
            activeId: '', // 当前选中的列表项索引
            orderList: [], // 订单列表
            listLoading: false, // 列表加载动画
            query: { pageNo: 1, pageSize: 10 }, // 分页
            dictData: {}, // 字典数据
            searchParams: {} // 查询参数
        };
    },
    computed: {
        ...mapState({
            supplier: state => state.supplier,
            currentTenant: state => state.currentTenant
        })
    },
    mounted () {},
    methods: {
        // 初始化查询
        async getList () {
            await this.getDictData();
            await this.getMapMonitorList();
            this.getListPageCount();
        },
        /**
         * @description 获取数据字典
         * TMS_TASK_STATUS: tms运输单状态
         */
        getDictData () {
            return dictWithUrl('TMS_TASK_STATUS').then(res => {
                if (res && +res.code === 0) {
                    this.dictData = res.data || {};
                }
            });
        },
        // 获取运单监控列表
        getMapMonitorList (searchData = {}) {
            this.activeId = '';
            this.listLoading = true;
            const params = {
                ...this.query,
                param: {
                    ...searchData,
                    carrierCode: this.supplier.supplierCode
                }
            };
            return queryMapMonitorList(params).then(res => {
                if (res && +res.code === 0) {
                    this.orderList = res.data.list || [];
                }
            }).finally(() => { this.listLoading = false; });
        },
        /**
         * @description 获取列表分页数据
         */
        getListPageCount (searchData = {}) {
            const params = {
                ...this.query,
                param: {
                    ...searchData,
                    carrierCode: this.supplier.supplierCode
                }
            };
            queryCount(params).then(res => {
                if (res && +res.code === 0) {
                    this.pageTotal = res.data || 0;
                }
            });
        },
        /**
         * @description 点击左侧列表项
         * @param {Object} item 当前操作列表项数据
         */
        handleChange (item) {
            this.activeId = item.id;
            this.$emit('change', item);
            this.closeSearchForm();
        },
        /**
         * @description 查询
         * @param {Object} searchData 查询数据
         */
        async handleSearch (searchData) {
            this.visibleSearchForm = false;
            this.query.pageNo = 1;
            this.searchParams = searchData;
            this.getListPageCount(searchData);
            await this.getMapMonitorList(searchData);
        },
        // 刷新
        handleRefresh () {
            this.query.pageNo = 1;
            this.query.pageSize = 10;
            this.searchParams = {};
            this.inputPageNo = 1;
            this.orderList = [];
            this.closeSearchForm();
            this.getMapMonitorList();
            this.getListPageCount();
        },
        // 展开收缩左侧列表
        handleExpand () {
            this.$emit('expand');
        },
        // 切换当前分页
        handleCurrentChange (pageNo) {
            this.query.pageNo = pageNo;
            this.inputPageNo = pageNo;
            this.getMapMonitorList(this.searchParams);
        },
        // 点击搜索图标
        handleClickSearch () {
            this.visibleSearchForm = !this.visibleSearchForm;
            this.$emit('clickSearch');
        },
        // 关闭查询表单
        closeSearchForm () {
            if (this.visibleSearchForm) { // 关闭已打开的搜索表单
                this.visibleSearchForm = false;
            }
        },
        // 查看运单轨迹
        async search (data) {
            await this.getDictData();
            await this.handleSearch(data);
            this.handleChange(this.orderList[0]);
        }
    },
    watch: {
        isExpand (val) { // 监听是否收缩左侧，将已打开的查询表单关闭掉
            !val && (this.visibleSearchForm = false);
        }
    }
};
</script>
<style lang="less">
@import url('./waybillList.less');
.order-list-main {
    min-height: calc(~'100vh - 80px');
}
.order-list {
    height: calc(~'100vh - 140px');
}
</style>
